import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { showNotification } from "Common/utils/Notification";
import { useParams } from "react-router-dom";
import BreadCrumb from "Common/BreadCrumb";
import { SUB_CATEGORY_UPDATE_ROUTE, SUB_CATEGORY_LIST_ROUTE } from "constants/routeEnum";
import { ToastContainer } from "react-toastify";
import LoaderComponent from "Common/Components/Loader/Loader";

const UpdateSubCategory = () => {
  const navigate = useNavigate();
  const [buttons, setButtons] = useState<any>([]);
  const { id } = useParams();
  const [loader, setLoader] = useState<any>(false);
  const [headerText, setHeaderText] = useState<any>();

  const [errors, setErrors] = useState<any>({
    banner_header_text: "",

    buttons: buttons?.map(() => ({ label: "", value: "" })),
  });

  useEffect(() => {
    async function fetchContent(id) {
      try {
        const res = await callApi(`v1/subcategory/${id}`, "get", {});
        if (res && res?.status === "Success") {
          setButtons(res.data.subcategory.params);
          setHeaderText(res.data.subcategory.name);
        }
      } catch (e) {
        showNotification(
          "An error occurred while fetching data. Please try again.",
          "error"
        );
        console.log("mmmmm", e);
      }
    }
    if (id) {
      fetchContent(id);
    }
  }, [id]);

  const addButton = () => {
    setButtons([...buttons, { label: "", value: "" }]);
    let newErrors = { ...errors };
    newErrors.buttons.push({ label: "", value: "" });
    setErrors(newErrors);
  };

  const removeButton = (index) => {
    const updatedButtons = buttons?.filter((_, i) => i !== index);
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    updatedErrors.buttons.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleInputChange = (index, field, value) => {
    const updatedButtons = buttons?.map((button, i) => {
      if (i === index) {
        button[field] = value;
      }
      return button;
    });
    setButtons(updatedButtons);

    const updatedErrors = { ...errors };
    if (updatedErrors.buttons[index]) {
      updatedErrors.buttons[index][field] = "";
    }
    setErrors(updatedErrors);
  };

  const handleSave = async (id) => {
    const newErrors = {
      banner_header_text:
        headerText.trim() === "" ? "Please enter sub category." : "",

      buttons: buttons?.map(() => ({ label: "", value: "" })),
    };

    buttons?.forEach((button, index) => {
      if (!button.label.trim()) {
        newErrors.buttons[index].label = "label is required .";
      }
      if (!button.value.trim()) {
        newErrors.buttons[index].value = "value is required .";
      }
    });

    setErrors(newErrors);

    if (
      !newErrors.banner_header_text &&
      newErrors?.buttons?.every((error) => !error.label && !error.value)
    ) {
      const payload = {
        name: headerText,
        params: buttons,
      };
      try {
        setLoader(true);
        const res = await callApi(`v1/subcategory/${id}/update`, "post", {
          content: payload,
        });
        setLoader(false);
        if (res && res?.status === "Success") {
          showNotification(" Updated successfully!", "success");

          navigate(SUB_CATEGORY_LIST_ROUTE);
        } else {
          showNotification("Something went wrong. Please try again.", "error");
        }
      } catch (e) {
        showNotification("An error occurred . Please try again.", "error");
      }
    }
  };

  return (
    <>
      <BreadCrumb
        title={SUB_CATEGORY_UPDATE_ROUTE.replace(":id", id)}
        pageTitle={SUB_CATEGORY_LIST_ROUTE}
        version="v1"
      />
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            {/* <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <div className="mb-4 xl:col-span-12"> */}
            <label className="inline-block mb-2 text-base font-medium">
              Code
            </label>
            <input
              type="text"
              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="Enter Banner Header Text"
              value={headerText}
              onChange={(e) => {
                setHeaderText(e.target.value);
              }}
            />

            {/* Add Button */}
            <div className="flex justify-end my-4">
              <button
                onClick={addButton}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add Code
              </button>
            </div>

            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              {/* Render Buttons */}
              {buttons?.map((button, index) => (
                <div key={index} className="py-4 xl:col-span-4">
                  <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
                    <label className="inline-block mb-2 text-base font-medium">
                      Label
                    </label>
                    <input
                      type="text"
                      value={button.label}
                      onChange={(e) =>
                        handleInputChange(index, "label", e.target.value)
                      }
                      className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Enter Label"
                    />
                    {errors.buttons[index]?.label && (
                      <p className="my-2 text-red-500">
                        {errors.buttons[index]?.label}
                      </p>
                    )}
                    <label className="inline-block mb-2 text-base font-medium">
                      Value
                    </label>
                    <input
                      type="text"
                      value={button.value}
                      onChange={(e) =>
                        handleInputChange(index, "value", e.target.value)
                      }
                      className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Enter Value"
                    />
                    {errors.buttons[index]?.value && (
                      <p className="my-2 text-red-500">
                        {errors.buttons[index]?.value}
                      </p>
                    )}
                    <div className="flex justify-end mt-2">
                      <button
                        onClick={() => removeButton(index)}
                        className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Save Button */}
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => handleSave(id)}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {loader ? <LoaderComponent /> : "Save"}
              </button>

              <Link
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                to={SUB_CATEGORY_LIST_ROUTE}
              >
                cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateSubCategory;
